import GuestPriceSFC from "./GuestPrice.vue";
export const GuestPrice = GuestPriceSFC;
